export default __webpack_public_path__ + "static/media/thumb-NDNU-2.350bd698.png";